import React, { useEffect, useState } from "react";
import styles from "./Wave.module.css";

const WaveBottom = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.waveBottom}>
      <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
        {isMobile ? (
          // ✅ MOBILE (less curves)
          <path
            fill="#FFFDF8"
            d="M0,200 
               C300,150 600,250 900,200 
               C1200,150 1440,200 1440,200 
               L1440,320 L0,320 Z"
          />
        ) : (
          // ✅ DESKTOP (original)
          <path
            fill="#FFFDF8"
            d="M0,200 
               C120,100 240,300 360,200 
               C480,100 600,300 720,200 
               C840,100 960,300 1080,200 
               C1200,100 1320,300 1440,200 
               L1440,320 L0,320 Z"
          />
        )}
      </svg>
    </div>
  );
};

export default WaveBottom;




// import React from "react";
// import styles from "./Wave.module.css";

// const WaveBottom = () => {
//   return (
//     <div className={styles.waveBottom}>
//       <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
//         <path
//           fill="#FFFDF8"
//           d="M0,200 
//        C120,100 240,300 360,200 
//        C480,100 600,300 720,200 
//        C840,100 960,300 1080,200 
//        C1200,100 1320,300 1440,200 
//        L1440,320 L0,320 Z"
//         />
//       </svg>
//     </div>
//   );
// };

// export default WaveBottom;